@if ((allNotifications$ | async).length > 0) {
  <div class="container">
    <p-panel>
      <p-header>Benachrichtigungen</p-header>
      @for (notification of allNotifications$ | async; track notification.message) {
        <div class="grid">
          <div class="col-2">
            <button  (click)="gotoMenueItem($event, notification)"
              class="transparentButton" >
              <mat-icon [ngClass]="notification.iconClass" [title]="notification.tooltip">
                {{notification.icon}}
              </mat-icon>
            </button>
          </div>
          <div class="col">
            <label style="padding-top: 1%;">
              {{notification.message}}
            </label>
          </div>
          <div class="col-1">
            <button  (click)="gotoNotifications($event, notification)"
              class="transparentButton" >
              <mat-icon [ngClass]="notification.iconClass" [title]="'Anzeigen...'">
                open_in_new
              </mat-icon>
            </button>
          </div>
          <div class="col-1">
            @if (canClear(notification)) {
              <button (click)="clearNotifications($event, notification)"
                style="border-color: transparent; background-color: transparent; color: red; font-weight: bold; ">
                <mat-icon [ngClass]="notification.iconClass" [title]="'Entfernen...'">
                  clear
                </mat-icon>
              </button>
            }
          </div>
        </div>
      }
    </p-panel>
  </div>
}
